import type { ComponentProps } from "react";

import { cn } from "../../lib/cn";
import { buttonClassName, type ButtonStyle } from "./button-styles";

export interface ButtonProps extends ComponentProps<"button">, ButtonStyle {}

export function Button({ variant, size, type = "button", className, ...props }: ButtonProps) {
	return <button type={type} className={buttonClassName({ variant, size }, className)} {...props} />;
}

export interface IconButtonProps extends ComponentProps<"button"> {
	/** Icon-only buttons have no visible text, so an accessible name is required. */
	readonly "aria-label": string;
}

export function IconButton({ type = "button", className, ...props }: IconButtonProps) {
	return (
		<button
			type={type}
			className={cn(
				"flex h-[30px] w-[30px] press cursor-pointer items-center justify-center rounded-ctl border-0 bg-transparent text-ink-3 transition-colors duration-[120ms] hover:text-ink [&_svg]:h-3.5 [&_svg]:w-3.5 [&_svg]:fill-none [&_svg]:stroke-current [&_svg]:stroke-[1.6]",
				className,
			)}
			{...props}
		/>
	);
}
